import { registerLicense } from "@syncfusion/ej2-base";
import { Amplify } from "aws-amplify";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom/client";

import App from "./App";
import awsExports from "./aws-exports";
import { CardGridProvider } from "./core/CardGridContext";
import { DataGridProvider } from "./core/DataGridContext";
import SnackbarAction from "./mui-toolkit/SnackbarAction";
import ThemeProvider from "./theme/ThemeProvider";

Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById("root"));

// Syncfusion
registerLicense(import.meta.env.VITE_TILLEY_SYNCFUSION_LICENSE);

root.render(
  <ThemeProvider>
    <CardGridProvider>
      <DataGridProvider>
        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={5000}
          disableWindowBlurListener={true}
          action={(id) => <SnackbarAction id={id} />}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <App />
        </SnackbarProvider>
      </DataGridProvider>
    </CardGridProvider>
  </ThemeProvider>
);
